import { Component, OnInit } from '@angular/core';
import {
  FormBuilder,
  FormControl,
  ValidatorFn,
  Validators,
} from '@angular/forms';
import { ActivatedRoute } from '@angular/router';

import { statesOptions } from 'src/app/data/states';
import Utils, { GetHelper, UtilsValidators } from 'src/app/helpers/utils';
import { SignupService } from 'src/app/services/signup/signup.service';
import { UtilsService } from 'src/app/services/utils/utils.service';
import fakerbr from 'faker-br';
import { MaskPipe } from 'ngx-mask';
import { ToastService } from 'src/app/services/toast/toast.service';
import { AuthService } from 'src/app/services/auth/auth.service';
import { distinctUntilChanged } from 'rxjs/operators';

import DDIOptions from 'src/app/data/ddi';
import { ApiService } from 'src/app/services/api/api.service';
import faker from '@faker-js/faker';

type FormFields = {
  [key: string]: [any, ValidatorFn[]];
};

@Component({
  selector: 'app-signup-unified-person-complementary-representatives',
  templateUrl:
    './signup-unified-person-complementary-representatives.component.html',
  styleUrls: [
    './signup-unified-person-complementary-representatives.component.scss',
  ],
})
export class SignupUnifiedPersonComplementaryRepresentativesComponent
  implements OnInit
{
  DDIOptions = DDIOptions;

  user_form_fields: FormFields = {
    birth_date: [null, []],
    marital_status: [null, []],
    document_type: [null, [Validators.required]],
    nationality: ['23', []],
    naturalness: [null, []],
    naturalness_city: [null, []],
    rg: [null, [Validators.required, Validators.pattern('')]],
    issuing_agency: [null, [Validators.required]],
    issuing_uf: [null, [Validators.required]],
    shipping_date: [
      null,
      [Validators.required, Utils.validateMaxMinToday, Utils.validateMinDate],
    ],
    celphone_ddi: ['55', [Validators.required]],
    celphone_number: [null, [Validators.required, UtilsValidators.celular]],

    email: [null, [Validators.required, Validators.email]],

    occupation: [null, []],

    zipcode: [null, [Validators.required, UtilsValidators.cep]],
    public_place: [null, [Validators.required]],
    number: [null, [Validators.required, Validators.max(99999)]],
    complement: [null, []],
    district: [null, [Validators.required]],
    city: [null, [Validators.required]],
    uf: [null, [Validators.required]],
    country: [null, []],

    spouse_name: [null, []],
    spouse_document: [null, []],
    spouse_statute: [null, []],
  };

  representative_form_fields: FormFields = {
    representative_type: ['person', []], // 'person' ou 'company'
    document: [null, [Validators.required, UtilsValidators.cpf]],
    cnpj: [null, []],
    company_name: [null, []],
    full_name: [null, [Validators.required]],

    indefinite_term: [null, []],
    term_validity: [
      null,
      [Validators.required, Utils.validateMaxMinToday, Utils.validateMinDate],
    ],
    max_term_validity: [
      null,
      [
        Validators.required,
        (control: FormControl) => Utils.validateMaxMinToday(control, false),
        Utils.validateMaxDate,
      ],
    ],

    pep: [false, []],
  };

  form_fields = {
    ...this.user_form_fields,
    ...this.representative_form_fields,
  };

  form = this.formBuilder.group(this.form_fields);

  haveAgent = false;
  showForm = true;

  columns: TableColumn<RepresentativeResponse>[] = [
    {
      name: 'Nome/Razão social',
      cell: (row) => this.getRepresentativeName(row),
    },
    {
      name: 'CPF/CNPJ',
      cell: (row) => this.getRepresentativeDocument(row),
    },
    {
      name: 'Tipo',
      cell: (row) => this.getRepresentativeType(row),
    },
  ];
  companyRepresentativesColumns: TableColumn<{
    name: string;
    document: string;
    canSign: boolean;
    isMandatory: boolean;
  }>[] = [
    {
      name: 'Nome',
      cell: (row) => row.name,
    },
    {
      name: 'Documento',
      cell: (row) => this.formatCpfCnpj(row.document),
    },
    {
      name: 'Assina',
      cell: (row) => (row.canSign ? 'Sim' : 'Não'),
    },
    {
      name: 'Obrigatório',
      cell: (row) => (row.isMandatory ? 'Sim' : 'Não'),
    },
  ];

  data: RepresentativeResponse[] = [];

  selectedRepresentative: number | null = null;

  zipcodeFetched = false;
  representativeFetched = false;

  addressObj: AddressProps = {
    public_place: '',
    district: '',
    city: '',
    uf: '',
    country: '',
  };

  states = statesOptions;

  today = Utils.todayString();

  tomorrow = Utils.tomorrowString();

  isIndefinite = false;

  isForeign = false;

  addAnotherModal = false;

  loadingContent = true;

  searchingZipcode = false;

  removeModal = false;

  deletingRepresentative = false;

  loadingSignatureGroup = false;

  warningRemoveModal = false;

  selectedIndex = 0;

  cities_options: SelectItem[] = [];

  loadingRepresentative = false;

  private lastRepresentativeType: string | null = null;

  foundedRegister: Partial<Register> | null = null;

  companyLookupName: string | null = null;
  companyLookupId: string | null = null;
  companyRepresentativeRegisterUuid: string | null = null;
  companyLookupStatus: string | null = null;

  private lastCompanyCnpjDigits = '';
  private companyCnpjComplete = false;
  companyRepresentatives: Array<{
    name: string;
    document: string;
    canSign: boolean;
    isMandatory: boolean;
  }> = [];
  loadingCompanyRepresentatives = false;

  // Expandable company representatives
  expandedRows: Set<number> = new Set();
  companyRepresentativesMap: Map<number, Array<{
    name: string;
    document: string;
    canSign: boolean;
    isMandatory: boolean;
  }>> = new Map();
  loadingCompanyRepsMap: Map<number, boolean> = new Map();

  applyRepresentativeTypeValidations(type: string) {
    if (type === 'company') {
      // Se for empresa, validar CNPJ e Razão Social como obrigatórios
      this.form.controls.cnpj.setValidators([
        Validators.required,
        UtilsValidators.cnpj,
      ]);
      this.form.controls.company_name.setValidators([Validators.required]);
      this.resetCompanyLookupState();
    } else {
      // Se for pessoa, remover validação de CNPJ e Razão Social
      this.form.controls.cnpj.setValidators([]);
      this.form.controls.cnpj.setValue(null);
      this.form.controls.company_name.setValidators([]);
      this.form.controls.company_name.setValue(null);
      this.representativeFetched = false;
      this.resetCompanyLookupState();
    }
    this.form.controls.cnpj.updateValueAndValidity();
    this.form.controls.company_name.updateValueAndValidity();
  }
  foundSpouse = false;

  sending = false;

  constructor(
    private formBuilder: FormBuilder,
    public signupService: SignupService,
    private utilsService: UtilsService,
    private maskPipe: MaskPipe,
    private toastService: ToastService,
    private api: ApiService,
    private toast: ToastService,
    private authService: AuthService,
    private route: ActivatedRoute
  ) {}

  ngOnInit(): void {
    this.getDataAndFillForm();

    document.onkeyup = (event) => {
      event.preventDefault();
      if (event.key === 'Enter' && this.form.valid) {
        this.triggerForm();
      }
    };

    this.form.controls.naturalness.valueChanges.subscribe((naturalness) => {
      if (naturalness !== null && naturalness !== '') {
        this.getCities(naturalness);
      }

      this.form.controls.naturalness_city.reset();
      this.form.controls.naturalness_city.updateValueAndValidity();
    });

    this.form.controls.spouse_document.valueChanges.subscribe(async (value) => {
      const document = this.form.controls.document.value;

      if (value && value.length === 14) {
        if (value === document) {
          this.form.controls.spouse_document.setErrors({ invalid: true });
          return;
        } else {
          this.form.controls.spouse_document.setErrors(null);
        }

        const { name, foundPerson } = await this.api.getPersonName(value);

        this.foundSpouse = foundPerson;

        if (name) this.form.controls.spouse_name.setValue(name);
      }
    });

    // this.form.controls.term_validity.valueChanges
    //   .pipe(distinctUntilChanged((a: any, b: any) => a === b))
    //   .subscribe((value) => {
    //     if (!value) {
    //       this.form.controls.term_validity.setValidators([]);
    //     } else {
    //       this.form.controls.term_validity.setValidators([
    //         Validators.required,
    //         Utils.validateMaxMinToday,
    //         Utils.validateMinDate,
    //       ]);
    //     }
    //     this.form.controls.term_validity.updateValueAndValidity();
    //   });

    // this.form.controls.max_term_validity.valueChanges
    //   .pipe(distinctUntilChanged((a: any, b: any) => a === b))
    //   .subscribe((value) => {
    //     if (!value) {
    //       this.form.controls.max_term_validity.setValidators([]);
    //     } else {
    //       this.form.controls.max_term_validity.setValidators([
    //         Validators.required,
    //         (control: FormControl) => Utils.validateMaxMinToday(control, false),
    //         Utils.validateMaxDate,
    //       ]);
    //     }
    //     this.form.controls.max_term_validity.updateValueAndValidity();
    //   });

    this.form.controls.indefinite_term.valueChanges.subscribe((values) => {
      this.isIndefinite = values;

      if (values) {
        this.form.controls.max_term_validity.setValue(null);
        this.form.controls.max_term_validity.setValidators([]);
        this.form.controls.max_term_validity.disable();
      } else {
        this.form.controls.max_term_validity.setValidators([
          Validators.required,
          (control: FormControl) => Utils.validateMaxMinToday(control, false),
          Utils.validateMaxDate,
        ]);
        this.form.controls.max_term_validity.enable();
      }

      this.form.controls.max_term_validity.updateValueAndValidity();
    });

    this.form.controls.nationality.valueChanges
      .pipe(distinctUntilChanged())
      .subscribe((nationality) => {
        if (nationality !== '23') {
          this.form.controls.naturalness.setValue(null, { emitEvent: false });
          this.form.controls.naturalness_city.setValue(null, {
            emitEvent: false,
          });
          this.form.controls.naturalness.setValidators([]);
          this.form.controls.naturalness_city.setValidators([]);

          this.isForeign = true;
        } else {
          if (
            this.authService.user.active_register.register.role.applicable ===
            'provider'
          ) {
            this.form.controls.naturalness.setValidators([Validators.required]);
            this.form.controls.naturalness_city.setValidators([
              Validators.required,
            ]);
          }

          this.isForeign = false;
        }

        this.form.controls.naturalness.updateValueAndValidity();
        this.form.controls.naturalness_city.updateValueAndValidity();
      });

    this.form.controls.marital_status.valueChanges.subscribe(() =>
      this.setMarried()
    );

    // Aplicar validações iniciais
    this.applyRepresentativeTypeValidations(
      this.form.controls.representative_type.value
    );

    // Aplicar validações quando o tipo mudar
    this.form.controls.representative_type.valueChanges
      .pipe(distinctUntilChanged())
      .subscribe((type) => {
        const previousType = this.lastRepresentativeType;
        this.lastRepresentativeType = type;

        // Aplicar validações do novo tipo
        this.applyRepresentativeTypeValidations(type);
      });

    this.form.controls.birth_date.valueChanges
      .pipe(distinctUntilChanged((a: any, b: any) => a === b))
      .subscribe((value) => {
        if (value) {
          this.form.controls.birth_date.setValidators([
            Validators.required,
            Utils.validateMinDate,
            Utils.validateLegalAge,
          ]);
        } else {
          this.form.controls.birth_date.setValidators([]);
        }

        this.form.controls.birth_date.updateValueAndValidity();

        this.form.controls.shipping_date.setValidators([
          Validators.required,
          Utils.validateMaxMinToday,
          Utils.validateMinDate,
          (control: FormControl) => {
            if (!control.value || !value) return null;

            const birthDateArr = value.split('/');

            const birthDateDay = birthDateArr[0];
            const birthDateMonth = birthDateArr[1];
            const birthDateYear = birthDateArr[2];

            const birthDate = new Date(
              birthDateYear,
              birthDateMonth - 1,
              birthDateDay
            );

            const shipping_dateArr = control.value.split('/');

            const shippingDateDay = shipping_dateArr[0];
            const shippingDateMonth = shipping_dateArr[1];
            const shippingDateYear = shipping_dateArr[2];

            const shippingDate = new Date(
              shippingDateYear,
              shippingDateMonth - 1,
              shippingDateDay
            );

            if (shippingDate < birthDate) {
              return { minDate: true };
            }

            return null;
          },
        ]);

        this.form.controls.shipping_date.updateValueAndValidity();
      });

    this.form.controls.shipping_date.valueChanges
      .pipe(distinctUntilChanged((a: any, b: any) => a === b))
      .subscribe(() => {
        const value = this.form.controls.birth_date.value;

        this.form.controls.shipping_date.setValidators([
          Validators.required,
          Utils.validateMaxMinToday,
          Utils.validateMinDate,
          (control: FormControl) => {
            if (!control.value || !value) return null;

            const birthDateArr = value.split('/');

            const birthDateDay = birthDateArr[0];
            const birthDateMonth = birthDateArr[1];
            const birthDateYear = birthDateArr[2];

            const birthDate = new Date(
              birthDateYear,
              birthDateMonth - 1,
              birthDateDay
            );

            const shipping_dateArr = control.value.split('/');

            const shippingDateDay = shipping_dateArr[0];
            const shippingDateMonth = shipping_dateArr[1];
            const shippingDateYear = shipping_dateArr[2];

            const shippingDate = new Date(
              shippingDateYear,
              shippingDateMonth - 1,
              shippingDateDay
            );

            if (shippingDate < birthDate) {
              return { minDate: true };
            }

            return null;
          },
        ]);

        this.form.controls.shipping_date.updateValueAndValidity();
      });

    this.signupService.choicesFetchedEvent.subscribe(() => this.setMarried());

    this.signupService.fillFormEvent.subscribe(() => {
      this.haveAgent = true;

      const zipcode = fakerbr.address.zipCodeValidByState('SP');

      const formatted = this.maskPipe.transform(zipcode, '00000-000');

      const userDocument = this.maskPipe.transform(
        fakerbr.br.cpf(),
        '000.000.000-00'
      );

      const birthdate_date = new Date();
      birthdate_date.setFullYear(birthdate_date.getFullYear() - 25);

      if (this.foundedRegister === null) {
        this.form.patchValue({
          document: userDocument,
          full_name: fakerbr.name.findName(),

          birth_date: birthdate_date.toLocaleDateString('pt-BR', {
            timeZone: 'UTC',
            day: '2-digit',
            month: '2-digit',
            year: 'numeric',
          }),
          marital_status: String(fakerbr.random.number({ min: 1, max: 6 })),
          document_type: String(fakerbr.random.number({ min: 1, max: 2 })),
          rg: String(fakerbr.random.number({ min: 100000000, max: 999999999 })),

          issuing_agency: 'SSP - Secretaria de Segurança Pública',
          issuing_uf: 'SP',
          nationality: '23',
          naturalness: 1,
          naturalness_city: 4707,

          shipping_date: fakerbr.date.past(10).toLocaleDateString('pt-BR', {
            timeZone: 'UTC',
            day: '2-digit',
            month: '2-digit',
            year: 'numeric',
          }),
          celphone_ddi: '55',
          celphone_number: this.maskPipe.transform(
            '139' +
              String(fakerbr.random.number({ min: 11111111, max: 99999999 })),
            '(00) 00000-0000'
          ),

          email: fakerbr.internet.email(),
          occupation: fakerbr.name.jobDescriptor(),
          max_term_validity: fakerbr.date
            .future(10)
            .toLocaleDateString('pt-BR', {
              timeZone: 'UTC',
              day: '2-digit',
              month: '2-digit',
              year: 'numeric',
            }),
          term_validity: fakerbr.date.past(2).toLocaleDateString('pt-BR', {
            timeZone: 'UTC',
            day: '2-digit',
            month: '2-digit',
            year: 'numeric',
          }),
          pep: false,

          zipcode: formatted,
          number: fakerbr.random.number({ min: 1, max: 1000 }),
          complement: 'Casa',
          country: '23',

          spouse_name: fakerbr.name.findName(undefined, undefined, 'female'),
          spouse_document: this.maskPipe.transform(
            fakerbr.br.cpf(),
            '000.000.000-00'
          ),
          spouse_statute: '1',
        });

        this.handleSearchZipcode({
          target: { value: formatted },
        });

        this.zipcodeFetched = true;

        this.searchRepresentative(userDocument, true);
      } else {
        this.form.patchValue({
          indefinite_term: false,
          email: fakerbr.internet.email(),
          max_term_validity: fakerbr.date
            .future(10)
            .toLocaleDateString('pt-BR', {
              timeZone: 'UTC',
              day: '2-digit',
              month: '2-digit',
              year: 'numeric',
            }),
          term_validity: fakerbr.date.past(2).toLocaleDateString('pt-BR', {
            timeZone: 'UTC',
            day: '2-digit',
            month: '2-digit',
            year: 'numeric',
          }),
        });
      }
    });
  }

  setRequiredFields() {
    if (
      this.authService.user.active_register.register.role.applicable ===
      'provider'
    ) {
      this.form.controls.birth_date.setValidators([
        Validators.required,
        Utils.ageValidation,
      ]);
      this.form.controls.occupation.setValidators([Validators.required]);
      this.form.controls.nationality.setValidators([Validators.required]);
      this.form.controls.naturalness.setValidators([Validators.required]);
      this.form.controls.naturalness_city.setValidators([Validators.required]);

      this.form.updateValueAndValidity();
    }
  }

  async getCities(state: number) {
    try {
      const res = await this.api.get({
        route: `api/registration/city`,
        params: { state },
        token: true,
      });

      this.cities_options = res.map((city: { name: string; id: number }) => ({
        label: city.name,
        value: city.id,
      }));

      if (this.selectedRepresentative !== null) {
        const data = this.data[this.selectedRepresentative];

        const sameState =
          data.representative_register.person.naturalness_state.id === state;

        if (sameState) {
          const cityId = data.naturalness_city
            ? data.naturalness_city.id
            : data.representative_register.person.naturalness_city?.id;

          // Limpar explicitamente antes de preencher
          this.form.controls.naturalness_city.setValue(null, {
            emitEvent: false,
          });

          // Preencher apenas com o ID
          if (cityId) {
            this.form.controls.naturalness_city.setValue(cityId, {
              emitEvent: false,
            });
          }
        }
      }

      if (this.foundedRegister !== null && this.foundedRegister.person) {
        const cityIdFromFounded =
          this.foundedRegister.person?.naturalness_city?.id;

        this.form.patchValue(
          {
            naturalness_city: cityIdFromFounded,
          },
          { emitEvent: false }
        );
      }
    } catch (error) {
      console.error(error);
      //   this.toastService.show('error', 'Erro', 'Erro ao recuperar cidades');
    }
  }

  setMarried() {
    if (
      this.form.controls.marital_status.value === '2' ||
      this.form.controls.marital_status.value === '3'
    ) {
      this.form.controls.spouse_name.setValidators([Validators.required]);
      this.form.controls.spouse_document.setValidators([
        Validators.required,
        UtilsValidators.cpf,
        (control: FormControl) => {
          const removeSpecialCharacters = control.value
            ? control.value.replace(/[^0-9]/g, '')
            : '';
          const userDocument = this.authService.user?.documents?.number.replace(
            /[^0-9]/g,
            ''
          );
          return userDocument === removeSpecialCharacters
            ? { invalid: true }
            : null;
        },
      ]);

      if (this.form.controls.spouse_document.value) {
        const document = this.form.controls.document.value;
        const spouseDocument = this.form.controls.spouse_document.value;

        if (spouseDocument && spouseDocument.length === 14) {
          if (spouseDocument === document) {
            this.form.controls.spouse_document.setErrors({ invalid: true });
          } else {
            this.form.controls.spouse_document.setErrors(null);
          }
        }
      }

      this.form.controls.spouse_statute.setValidators([Validators.required]);
    } else {
      this.form.controls.spouse_name.setValidators([]);
      this.form.controls.spouse_document.setValidators([]);
      this.form.controls.spouse_statute.setValidators([]);
    }

    this.form.controls.spouse_name.updateValueAndValidity();
    this.form.controls.spouse_document.updateValueAndValidity();
    this.form.controls.spouse_statute.updateValueAndValidity();
  }

  handleEditData(index: number) {
    const data = this.data[index];

    // Verificar se há dados de empresa primeiro
    const companyData =
      data.info?.company ||
      data.info?.register?.company ||
      data.representative_register?.company;
    const hasCompanyData =
      companyData &&
      ((companyData.document?.number &&
        companyData.document.number.trim() !== '') ||
        (companyData.corporate_name &&
          companyData.corporate_name.trim() !== ''));
    const isCompany = !!hasCompanyData;
    const representativeType = isCompany ? 'company' : 'person';

    // Para empresa, person pode ser null, então precisamos de verificações
    const data_person = data.representative_register.person || ({} as any);

    const data_address =
      data.representative_register.address ?? 
      data.info?.register?.address ?? 
      ({} as any);

    const secondary_document =
      data_person.secondary_document ??
      data.info?.register?.person?.secondary_document ??
      ({} as any);

    const phone =
      data.representative_register.person?.phone ??
      data.info?.register?.person?.cellphone ??
      ({} as any);

    this.setUserFieldsValidation(false);
    // Garantir o tipo correto na edição antes do patch
    this.form.controls.representative_type.setValue(representativeType, {
      emitEvent: false,
    });
    this.foundedRegister = {
      id: data.representative_register.id,
    };

    this.selectedRepresentative = index;
    this.addAnotherModal = true;
    this.signupService.setPersonFormStatus(
      'complementaryRepresentatives',
      false
    );
    this.zipcodeFetched = true;
    this.representativeFetched = true;

    // Criar objeto sem naturalness_city e naturalness_state para evitar passar objetos completos
    const {
      naturalness_city,
      naturalness_state,
      ...personWithoutCityAndState
    } = data_person;

    let patchData: any = {};

    // Se for empresa, preencher apenas campos de mandato e empresa
    if (isCompany) {
      patchData = {
        representative_type: representativeType,
        term_validity: data.min_term_validity 
          ? data.min_term_validity.split('-').reverse().join('/')
          : null,
        max_term_validity: data.max_term_validity
          ? data.max_term_validity.split('-').reverse().join('/')
          : null,
        indefinite_term: data.max_term_validity ? false : true,
      };

      // Adicionar CNPJ e Razão Social
      if (hasCompanyData && companyData) {
        patchData.cnpj = companyData.document?.number
          ? this.maskPipe.transform(
              companyData.document.number,
              '00.000.000/0000-00'
            )
          : null;
        patchData.company_name = companyData.corporate_name || null;
        this.companyLookupName = companyData.corporate_name || null;
        this.companyLookupStatus =
          (companyData.status || '').toLowerCase() === 'homologado'
            ? 'homologado'
            : (companyData.status || 'NÃO HOMOLOGADO');
        this.companyRepresentativeRegisterUuid =
          companyData.register_uuid || this.getCompanyUuid(data);
        this.loadCompanyRepresentativesForEdit(
          this.companyRepresentativeRegisterUuid
        );
      }
    } else {
      // Se for pessoa, preencher todos os campos normalmente
      patchData = {
        ...personWithoutCityAndState,
        ...data_address,
        country: String(data_address.country),
        birth_date: this.renderBirthDate(data),
        full_name: data.full_name ?? data_person.full_name,
        document: this.maskPipe.transform(data.document_number, '000.000.000-00'),
        pep: data.pep,
        representative_type: representativeType,

        document_type: data_person.secondary_document
          ? String(data_person.secondary_document?.type?.id)
          : data.info.register.person.secondary_document?.type,

        email: data_person.email,
        term_validity: data.min_term_validity 
          ? data.min_term_validity.split('-').reverse().join('/')
          : null,
        max_term_validity: data.max_term_validity
          ? data.max_term_validity.split('-').reverse().join('/')
          : null,

        indefinite_term: data.max_term_validity ? false : true,
        marital_status: data_person.marital_status
          ? String(data_person.marital_status)
          : null,

        nationality: data_person.naturalness || '23',
        naturalness: data_person.naturalness_state?.id ?? null,
        naturalness_city: data_person.naturalness_city?.id ?? null,

        rg: secondary_document?.number,
        issuing_agency: secondary_document?.dispatching_agency,
        issuing_uf: secondary_document?.uf,
        shipping_date: secondary_document?.expedition_date
          .split('-')
          .reverse()
          .join('/'),
        celphone_ddi: String(phone.code),
        celphone_number: this.maskPipe.transform(
          '139' + phone.number,
          '(00) 00000-0000'
        ),

        zipcode: data_address.cep,
      };
    }

    // Limpar explicitamente o campo naturalness_city antes de preencher para evitar objetos antigos
    this.form.controls.naturalness_city.setValue(null, { emitEvent: false });

    // Atualizar isForeign ANTES do patchValue baseado no nationality que será preenchido
    this.isForeign = patchData.nationality !== '23';

    this.form.patchValue(patchData, { emitEvent: false });

    // Aplicar validações baseadas no tipo de representante
    if (isCompany) {
      this.form.controls.cnpj.setValidators([
        Validators.required,
        UtilsValidators.cnpj,
      ]);
      this.form.controls.company_name.setValidators([Validators.required]);
    } else {
      this.form.controls.cnpj.setValidators([]);
      this.form.controls.company_name.setValidators([]);
    }
    this.form.controls.cnpj.updateValueAndValidity();
    this.form.controls.company_name.updateValueAndValidity();

    // Carregar cidades se houver estado selecionado e não for estrangeiro
    if (data_person.naturalness_state?.id && !this.isForeign) {
      this.getCities(data_person.naturalness_state.id);
    }

    if (data_address && data_address.cep) {
      this.handleSearchZipcode({
        target: { value: data_address.cep },
      });
    }

    if (
      String(data_person.marital_status) === '2' ||
      String(data_person.marital_status) === '3'
    ) {
      this.form.patchValue(
        {
          spouse_name: data_person.spouse.name,
          spouse_document: this.maskPipe.transform(
            data_person.spouse.document,
            '000.000.000-00'
          ),
          spouse_statute: String(data_person.spouse.marriage_bond),
        },
        { emitEvent: false }
      );
    }

    // Se for empresa:
    // 1. Desabilitar o campo CNPJ para não ser editável
    // 2. Desabilitar todos os campos que não são usados (campos de pessoa) para não impactar a validade do form
    if (isCompany) {
      // Usar setTimeout para garantir que a renderização termine
      setTimeout(() => {
        // Desabilitar CNPJ (será exibido mas read-only)
        this.form.controls.cnpj.disable();
        
        // Desabilitar nome da empresa
        this.form.controls.company_name.disable();

        // Desabilitar todos os campos de pessoa para remover da validação
        const personFields = [
          'document', 'full_name', 'birth_date', 'marital_status', 
          'nationality', 'naturalness', 'naturalness_city', 
          'document_type', 'rg', 'issuing_agency', 'issuing_uf', 'shipping_date',
          'celphone_ddi', 'celphone_number', 'zipcode', 'address', 'number', 
          'complement', 'neighborhood', 'city', 'state', 'country', 'email'
        ];

        personFields.forEach(field => {
          if (this.form.controls[field]) {
            this.form.controls[field].disable();
          }
        });
      }, 100);
    }
  }

  renderBirthDate(data: RepresentativeResponse) {
    if (data.birth_date) {
      return data.birth_date.split('-').reverse().join('/');
    }

    const birth_date = data.representative_register.person.birth_date;

    return birth_date ? birth_date.split('-').reverse().join('/') : null;
  }

  async handleRemoveData(index: number) {
    this.loadingSignatureGroup = true;
    try {
      // Pega o register_uuid da rota (obrigatório, sem fallback)
      const routeId = this.route.snapshot.paramMap.get('id');

      if (!routeId) {
        this.toast.show(
          'error',
          'Erro',
          'Register UUID não encontrado na rota'
        );
        this.loadingSignatureGroup = false;
        return;
      }

      const { data } = await this.api.get<ApiResponse<any[]>>({
        route: 'api/registration/signature-group/',
        params: { register_uuid: routeId },
        token: true,
      });

      let haveRepresent = false;

      data.forEach((item) => {
        item.members.forEach((integrant: any) => {
          if (integrant.id === this.data[index].id) {
            this.warningRemoveModal = true;
            haveRepresent = true;
          }
        });
      });

      if (haveRepresent) {
        this.loadingSignatureGroup = false;
        return;
      }

      this.removeModal = true;
      this.selectedIndex = index;
    } catch (error) {
      console.error('Erro ao verificar grupos de assinatura:', error);
      this.toast.show(
        'error',
        'Erro',
        'Erro ao verificar grupos de assinatura'
      );
    } finally {
      this.loadingSignatureGroup = false;
    }
  }

  handleRemoveCancel() {
    this.removeModal = false;
    this.selectedIndex = 0;
  }

  async removeData(index: number) {
    this.deletingRepresentative = true;
    try {
      // Pega o register_uuid da rota (obrigatório, sem fallback)
      const routeId = this.route.snapshot.paramMap.get('id');

      if (!routeId) {
        this.toast.show(
          'error',
          'Erro',
          'Register UUID não encontrado na rota'
        );
        this.deletingRepresentative = false;
        return;
      }

      const findedRepresentative = this.data[index];

      await this.api.delete<ApiResponse<null>>({
        route: `api/registration/representatives-data/${findedRepresentative.id}/`,
        params: { register_uuid: routeId },
        token: true,
      });

      this.handleRemoveCancel();

      // Ativar loadingContent antes de recarregar os dados
      this.loadingContent = true;
      await this.getDataAndFillForm();
    } catch (error) {
      this.toastService.show(
        'error',
        'Erro',
        error.error?.message || 'Erro ao remover representante'
      );
    } finally {
      this.deletingRepresentative = false;
    }
  }

  getDisabled() {
    const isCompany = this.form.controls.representative_type.value === 'company';
    
    // Bloquear se for empresa (nova) e não estiver homologada
    if (
      isCompany &&
      this.selectedRepresentative === null &&
      this.companyLookupStatus !== 'homologado'
    ) {
      return true;
    }

    const isCompanyFound = isCompany && this.representativeFetched;

    // Se for empresa e já encontrou a empresa (representativeFetched = true), liberar
    if (isCompanyFound) {
      // Verificar se os campos de mandato estão preenchidos
      const termValidity = this.form.controls.term_validity.value;
      const maxTermValidity = this.form.controls.max_term_validity.value;
      const indefiniteTerm = this.form.controls.indefinite_term.value;

      // Se for edição (selectedRepresentative !== null), ignorar validação de busca de empresa
      if (this.selectedRepresentative !== null) {
        const isTermValid = this.form.controls.term_validity.valid && !!this.form.controls.term_validity.value;
        const isMaxTermValid = this.form.controls.max_term_validity.valid && !!this.form.controls.max_term_validity.value;
        
        // Validar apenas mandato e não permitir salvar se tiver erro
        if (!isTermValid) return true;
        if (!indefiniteTerm && !isMaxTermValid) return true;
        
        return false; // Habilitar botão
      }

      // Se for novo (adicionar), manter validação de busca
      const cnpjValid = this.form.controls.cnpj.valid;
      const companyNameValid = this.form.controls.company_name.valid;
      
      // Validar campos de mandato
      const hasStartDate = this.form.controls.term_validity.value && this.form.controls.term_validity.valid;
      const hasEndDate = this.form.controls.max_term_validity.value && this.form.controls.max_term_validity.valid;
      const isIndefinite = this.form.controls.indefinite_term.value;
      const mandateValid = hasStartDate && (hasEndDate || isIndefinite);
      
      return !(cnpjValid && companyNameValid && this.companyLookupId && mandateValid);
    }

    if (this.addAnotherModal) {
      return this.form.invalid;
    }

    if (this.showForm) {
      return this.form.invalid;
    }

    return false;
  }

  async triggerForm() {
    if (this.showForm) {
      await this.sendData();
    } else {
      if (!this.addAnotherModal) {
        this.addAnotherModal = true;
        this.signupService.setPersonFormStatus(
          'complementaryRepresentatives',
          false
        );
      } else {
        await this.sendData();
      }
    }
  }

  setUserFieldsValidation(required: boolean) {
    // Object.entries(this.user_form_fields).forEach(
    //   ([key, [value, validator]]) => {
    //     if (required) {
    //       this.form.get(key).setValidators(validator);
    // this.form.get(key).setValue(value);
    // } else {
    //   this.form.get(key).setValidators([]);
    //   this.form.get(key).setValue(null);
    // }

    // update value and validity
    //     this.form.get(key).updateValueAndValidity();
    //   }
    // );
    if (required) {
      this.setRequiredFields();
    }
  }

  async searchRepresentative(event: any, simplified: boolean = false) {
    if (this.selectedRepresentative !== null) return;

    if (this.form.controls.representative_type.value === 'company') {
      this.loadingRepresentative = false;
      return;
    }

    this.loadingRepresentative = true;

    const document = simplified
      ? Utils.onlyNumbers(event)
      : Utils.onlyNumbers(event.target.value);

    // Preservar CNPJ e razão social se o tipo for empresa
    const preservedType = this.form.controls.representative_type.value;
    const preservedCnpj =
      preservedType === 'company' ? this.form.controls.cnpj.value : null;
    const preservedCompanyName =
      preservedType === 'company'
        ? this.form.controls.company_name.value
        : null;

    if (document.length === 11) {
      try {
        if (this.data.some((item) => item.document_number === document)) {
          this.toast.show('error', 'Atenção', 'Representante já adicionado');
          throw new Error('Representante já adicionado');
        }

        const { data } = await this.api.get<ApiResponse<Register | null>>({
          route: `api/registration/search/representative`,
          params: { query: document },
          token: true,
        });

        if (data) {
          this.foundedRegister = data;
          this.toast.show(
            'info',
            'Atenção',
            'Representante já cadastrado, cadastre os dados abaixo para prosseguir'
          );

          const person = data.person;

          delete person.document;

          // Criar objeto sem naturalness_city e naturalness_state para evitar passar objetos completos
          const {
            naturalness_city,
            naturalness_state,
            ...personWithoutCityAndState
          } = person;

          // CORREÇÃO: A API retorna nationality como string "Brasileiro" mas naturalness como "23" (ID do país)
          // Precisamos usar naturalness que contém o ID do país, não nationality que contém o nome
          // Se naturalness não existir, tentar usar nationality convertendo ou usar '23' como padrão
          let nationalityValue = '23'; // padrão Brasil

          if (data.person.naturalness) {
            // naturalness contém o ID do país como string
            nationalityValue = String(data.person.naturalness);
          } else if (data.person.nationality) {
            // Se naturalness não existir, tentar extrair o ID de nationality
            // Mas como nationality é "Brasileiro", vamos usar o padrão '23'
            nationalityValue = '23';
          }

          const patchData: any = {
            ...personWithoutCityAndState,
            ...data.address,
            birth_date: person.birth_date
              ? person.birth_date.split('-').reverse().join('/')
              : '',
            marital_status: person.marital_status
              ? String(person.marital_status)
              : null,
            country: data.address ? String(data.address.country) : '',

            full_name: data.person.full_name,
            document_type: person.secondary_document
              ? String(person?.secondary_document?.type?.id)
              : null,
            nationality: nationalityValue,
            naturalness: data.person.naturalness_state?.id ?? '',
            naturalness_city: data.person.naturalness_city?.id ?? null,
            rg: data.person.secondary_document?.number ?? '',
            issuing_agency:
              data.person.secondary_document?.dispatching_agency ?? null,
            issuing_uf: data.person.secondary_document?.uf ?? null,
            shipping_date: data.person.secondary_document
              ? data.person.secondary_document?.expedition_date
                  .split('-')
                  .reverse()
                  .join('/')
              : '',
            celphone_ddi: data.person.cellphone
              ? String(data.person.cellphone?.code)
              : null,
            celphone_number: data.person.cellphone
              ? this.maskPipe.transform(
                  '139' + data.person.cellphone.number,
                  '(00) 00000-0000'
                )
              : '',
            zipcode: data.address?.cep ?? '',
            spouse_name: data.person.spouse?.name ?? '',
            spouse_document: data.person.spouse
              ? this.maskPipe.transform(
                  data.person.spouse.document,
                  '000.000.000-00'
                )
              : '',
            spouse_statute: data.person.spouse?.marriage_bond ?? null,
            pep: data.person.pep_relationship,
          };

          // Atualizar isForeign ANTES do patchValue baseado no nationality que será preenchido
          this.isForeign = nationalityValue !== '23';

          // Aplicar patchValue sem disparar eventos para representative_type
          this.form.patchValue(patchData, { emitEvent: false });

          // Se o tipo mudou, atualizar separadamente
          if (this.form.controls.representative_type.value !== preservedType) {
            this.form.controls.representative_type.setValue(preservedType, {
              emitEvent: false,
            });
          }

          // Restaurar CNPJ e razão social se o tipo for empresa
          if (preservedType === 'company') {
            this.form.patchValue(
              {
                cnpj: preservedCnpj,
                company_name: preservedCompanyName,
              },
              { emitEvent: false }
            );
          }

          this.zipcodeFetched = data.address !== null;

          this.setUserFieldsValidation(false);

          // Reaplicar validações de empresa se necessário
          this.applyRepresentativeTypeValidations(preservedType);

          // Carregar cidades se houver estado selecionado e não for estrangeiro
          if (data.person.naturalness_state?.id && !this.isForeign) {
            this.getCities(data.person.naturalness_state.id);
          }
        } else {
          this.foundedRegister = null;

          this.form.patchValue(
            {
              nationality: '23',
              celphone_ddi: '55',
            },
            { emitEvent: false }
          );

          // Restaurar CNPJ e razão social se o tipo for empresa
          if (preservedType === 'company') {
            this.form.patchValue(
              {
                cnpj: preservedCnpj,
                company_name: preservedCompanyName,
              },
              { emitEvent: false }
            );
          }

          // Atualizar isForeign para false (Brasil)
          this.isForeign = false;

          // Se o tipo mudou, atualizar separadamente
          if (this.form.controls.representative_type.value !== preservedType) {
            this.form.controls.representative_type.setValue(preservedType, {
              emitEvent: false,
            });
          }

          this.setUserFieldsValidation(true);

          // Reaplicar validações de empresa se necessário
          this.applyRepresentativeTypeValidations(preservedType);

          // Só liberar campos se o CPF for válido (não liberar com CPF inválido)
          this.form.controls.document.updateValueAndValidity();
          if (!this.form.controls.document.valid) {
            this.representativeFetched = false;
            this.loadingRepresentative = false;
            return;
          }
        }

        this.representativeFetched = true;
      } catch (error) {
        this.representativeFetched = false;
        console.error(error);
      }
    } else {
      this.form.reset();
      this.form.patchValue(
        {
          document: simplified ? event : event.target.value,
          nationality: '23',
          celphone_ddi: '55',
        },
        { emitEvent: false }
      );

      // Restaurar CNPJ e razão social se o tipo for empresa
      if (preservedType === 'company') {
        this.form.patchValue(
          {
            cnpj: preservedCnpj,
            company_name: preservedCompanyName,
          },
          { emitEvent: false }
        );
      }

      // Atualizar isForeign para false (Brasil)
      this.isForeign = false;

      // Restaurar o tipo de representante sem disparar eventos
      this.form.controls.representative_type.setValue(preservedType, {
        emitEvent: false,
      });

      // Reaplicar validações de empresa se necessário
      this.applyRepresentativeTypeValidations(preservedType);

      this.representativeFetched = false;
    }
    this.loadingRepresentative = false;
  }

  async searchCompanyByCnpj(event: any) {
    if (this.selectedRepresentative !== null) return;

    const cnpjDigits = Utils.onlyNumbers(event.target.value);
    const isComplete = cnpjDigits.length === 14;

    if (!isComplete) {
      this.companyCnpjComplete = false;
      this.lastCompanyCnpjDigits = '';
      this.companyLookupName = null;
      this.companyLookupId = null;
      this.companyRepresentativeRegisterUuid = null;
      this.companyRepresentatives = [];
      this.loadingCompanyRepresentatives = false;
      this.form.controls.company_name.setValue(null, { emitEvent: false });
      this.representativeFetched = false;
      return;
    }

    const isNewAttempt =
      !this.companyCnpjComplete || this.lastCompanyCnpjDigits !== cnpjDigits;

    if (!isNewAttempt) return;

    if (
      this.data.some(
        (item) =>
          Utils.onlyNumbers(item.document_number) === cnpjDigits &&
          this.isCompanyRepresentative(item)
      )
    ) {
      this.toast.show('error', 'Atenção', 'Empresa já adicionada');
      return;
    }

    this.companyCnpjComplete = true;
    this.lastCompanyCnpjDigits = cnpjDigits;

    this.companyLookupName = null;
    this.companyLookupId = null;
    this.companyRepresentativeRegisterUuid = null;
    this.companyRepresentatives = [];
    this.form.controls.company_name.setValue(null, { emitEvent: false });
    this.representativeFetched = false;
    this.loadingCompanyRepresentatives = true;

    try {
      const res = await this.api.get<{
        id: string;
        document: string;
        name: string;
        type: string;
        current_stage: string;
      } | null>({
        route: 'api/v3/registration/registers/get-company-by-document/',
        params: { document: cnpjDigits },
        token: true,
      });

      if (res) {
        const isHomologado =
          (res.current_stage || '').toLowerCase() === 'homologado';

        this.companyLookupName = res.name || res.document || 'Empresa encontrada';
        this.companyLookupId = res.id || null;
        this.companyLookupStatus = isHomologado
          ? 'homologado'
          : (res.current_stage || 'NÃO HOMOLOGADO');
        this.companyRepresentativeRegisterUuid = res.id || null;

        this.form.controls.company_name.setValue(this.companyLookupName, {
          emitEvent: false,
        });

        if (isHomologado) {
          const signStatusRes = await this.api.get<{
            data: Array<{
              id: number;
              full_name: string;
              document_number: string;
              signs_registration_form: boolean;
              is_registration_form_mandatory: boolean;
              has_signed: boolean;
              representative_register_uuid: string;
            }>;
          } | null>({
            route: 'api/registration/registration-sign-status/',
            params: { register_uuid: res.id },
            token: true,
          });

          this.companyRepresentatives = (signStatusRes?.data || []).map(
            (item) => ({
              name: item.full_name,
              document: item.document_number,
              canSign: item.signs_registration_form,
              isMandatory: item.is_registration_form_mandatory,
            })
          );
        } else {
          this.companyRepresentatives = [];
        }

        this.representativeFetched = true;
        return;
      }

      this.toast.show(
        'info',
        'Empresa não encontrada',
        'Somente empresas cadastradas podem ser vinculadas como representante.'
      );
      this.companyLookupId = null;
    } catch (error) {
      console.error('Erro ao buscar empresa por CNPJ:', error);
      this.toast.show('error', 'Erro', 'Erro ao buscar empresa');
    } finally {
      this.loadingCompanyRepresentatives = false;
    }
  }

  async handleSearchZipcode(event: any) {
    this.searchingZipcode = true;
    const zipcode = event.target.value;

    var obj = {
      public_place: '',
      district: '',
      city: '',
      uf: '',
      country: '',
    };

    try {
      const zipcodeRes = await this.utilsService.getZipcode(zipcode);

      if (zipcodeRes) {
        const foundCep = Object.keys(zipcodeRes).some((key) => {
          return key === 'partner_response' ? false : zipcodeRes[key] !== '';
        });

        if (foundCep) {
          obj = {
            public_place: zipcodeRes.logradouro,
            district: zipcodeRes.bairro,
            city: zipcodeRes.localidade,
            uf: zipcodeRes.uf,
            country: '23',
          };

          this.form.patchValue(obj);

          this.zipcodeFetched = true;
        } else {
          //   Utils.resetZipcodeFields(this.form);
          this.form.updateValueAndValidity();

          this.zipcodeFetched = zipcode.length === 9;
        }
      }
    } catch (error) {
      this.zipcodeFetched = false;
      console.error(error);
    }

    this.addressObj = obj;

    this.searchingZipcode = false;
  }

  getChoices() {
    return this.signupService.choices();
  }

  handleCloseModal() {
    this.addAnotherModal = false;
    this.signupService.setPersonFormStatus(
      'complementaryRepresentatives',
      true
    );
    setTimeout(() => {
      this.form.reset();
      this.form.patchValue({
        representative_type: 'person',
        nationality: '23',
        celphone_ddi: '55',
      });
      this.enableAllControls();
      this.selectedRepresentative = null;
      this.foundedRegister = null;
      this.zipcodeFetched = false;
      this.representativeFetched = false;
      this.resetCompanyLookupState();
    }, 500);

  }

  clearForm() {
    this.form.reset();
    this.form.patchValue({
      representative_type: 'person',
      nationality: '23',
      celphone_ddi: '55',
    });
    this.enableAllControls();
    this.selectedRepresentative = null;
    this.foundedRegister = null;
    this.zipcodeFetched = false;
    this.representativeFetched = false;
    this.resetCompanyLookupState();
  }

  private enableAllControls() {
    Object.keys(this.form.controls).forEach((key) => {
      this.form.controls[key].enable({ emitEvent: false });
    });
  }


  private async loadCompanyRepresentativesForEdit(
    registerUuid: string | null
  ) {
    if (!registerUuid) {
      this.companyRepresentatives = [];
      return;
    }

    this.loadingCompanyRepresentatives = true;
    try {
      const res = await this.api.get<{
        data: Array<{
          id: number;
          full_name: string;
          document_number: string;
          signs_registration_form: boolean;
          is_registration_form_mandatory: boolean;
          has_signed: boolean;
          representative_register_uuid: string;
        }>;
      }>({
        route: 'api/registration/registration-sign-status/',
        params: { register_uuid: registerUuid },
        token: true,
      });

      this.companyRepresentatives = (res?.data || []).map((item) => ({
        name: item.full_name,
        document: item.document_number,
        canSign: item.signs_registration_form,
        isMandatory: item.is_registration_form_mandatory,
      }));
    } catch (error) {
      console.error('Error loading company representatives:', error);
      this.toastService.show(
        'error',
        'Erro',
        'Erro ao carregar representantes da empresa'
      );
      this.companyRepresentatives = [];
    } finally {
      this.loadingCompanyRepresentatives = false;
    }
  }

renderTitle() {
  let title = 'Adicionar representante';

  if (this.selectedRepresentative !== null) {
    const fullName = this.data[this.selectedRepresentative].full_name;
    if (fullName && fullName !== 'null') {
      title = `Editar representante ${fullName}`;
    } else {
      title = 'Editar representante';
    }
  }

  return title;
}

  async getDataAndFillForm() {
    this.loadingContent = true;
    try {
      // Pega o register_uuid da rota (obrigatório, sem fallback)
      const routeId = this.route.snapshot.paramMap.get('id');

      if (!routeId) {
        this.toast.show(
          'error',
          'Erro',
          'Register UUID não encontrado na rota'
        );
        this.loadingContent = false;
        return;
      }

      const { data } = await this.api.get<
        ApiResponse<RepresentativeResponse[]>
      >({
        route: 'api/registration/representatives-data/',
        token: true,
        params: {
          register_uuid: routeId,
        },
      });

      this.data = data;

      if (this.data.length > 0) {
        this.haveAgent = true;
      }

      this.showForm = !(this.data.length > 0);
      this.representativeFetched = false;

      // Emite o evento para todos os tipos de usuário para atualizar os steps
      this.signupService.checkRepresentativeDataEvent.emit(
        this.data.length > 0
      );

      // Se "Sou representado por um terceiro" estiver marcado e não há representantes, bloquear Seguir
      const shouldBlock =
        this.haveAgent && this.data.length === 0;
      this.signupService.setPersonFormStatus(
        'complementaryRepresentatives',
        !shouldBlock
      );
    } catch (error) {
      if (error.status !== 404) {
        this.toast.show(
          'error',
          'Erro',
          error.error?.message || 'Erro ao carregar representantes'
        );
      }
    }
    this.loadingContent = false;
  }

  async sendData() {
    this.sending = true;
    try {
      const valuesHelper = new GetHelper(this.form.getRawValue());
      const isCompany = valuesHelper.get('representative_type') === 'company';

      let payload: any;

      if (isCompany) {
        payload = {
          representative: {
            document_number: Utils.onlyNumbers(valuesHelper.get('cnpj')),
            can_sign: false,
            min_term_validity: valuesHelper.get('term_validity')
              ? valuesHelper.get('term_validity').split('/').reverse().join('-')
              : null,
            max_term_validity: 
              valuesHelper.get('indefinite_term') 
                ? null 
                : valuesHelper.get('max_term_validity')
                  ? valuesHelper.get('max_term_validity').split('/').reverse().join('-')
                  : null,
          },
          company: {
            register_uuid: this.companyRepresentativeRegisterUuid,
            corporate_name: valuesHelper.get('company_name'),
            document: {
              number: Utils.onlyNumbers(valuesHelper.get('cnpj')),
              type: 'CNPJ',
            },
          },
        };
      } else {
        payload = {
          representative: {
            birth_date: valuesHelper.get('birth_date')
              ? valuesHelper.get('birth_date').split('/').reverse().join('-')
              : null,
            document_number: Utils.onlyNumbers(valuesHelper.get('document')),
            full_name: valuesHelper.get('full_name'),
            email: valuesHelper.get('email'),

            can_sign: true,

            expiration_date: valuesHelper.get('max_term_validity')
              ? valuesHelper
                  .get('max_term_validity')
                  .split('/')
                  .reverse()
                  .join('-')
              : null,

            pep: valuesHelper.get('pep'),

            max_term_validity: valuesHelper.get('max_term_validity')
              ? valuesHelper
                  .get('max_term_validity')
                  .split('/')
                  .reverse()
                  .join('-')
              : null,
            min_term_validity: valuesHelper.get('term_validity')
              ? valuesHelper.get('term_validity').split('/').reverse().join('-')
              : null,
          },
        };
      }

      if (!isCompany) {
        const names = valuesHelper.get('full_name')
          ? valuesHelper.get('full_name').split(' ')
          : [];
        const [first_name, ...last_names] = names || [];
        const last_name = last_names?.join(' ') || '';

        const roles = this.signupService.getRoles();

        const role = roles.find((item) => item.slug === 'REPRESENTATIVE-PF-PF');

        const id = faker.datatype.uuid();

        payload['user'] = {
          username: Utils.onlyNumbers(valuesHelper.get('document')),
          first_name: first_name,
          last_name: last_name,
          type: 'PF',
          email: valuesHelper.get('email'),
          nationality: valuesHelper.get('nationality')
            ? Number(valuesHelper.get('nationality'))
            : null,
          password: id,
          phone: {
          type: 'phone',
          code: Number(valuesHelper.get('celphone_ddi')),
          number: Utils.onlyNumbers(valuesHelper.get('celphone_number')),
          branch: 0,
        },
        documents: {
          type: 'CPF',
          number: Utils.onlyNumbers(valuesHelper.get('document')),
        },
      };

        payload['register'] = {
          type: 'PF',
          role: role.id,
          address: {
            cep: valuesHelper.get('zipcode'),
            public_place: valuesHelper.get('public_place'),
            number: Number(valuesHelper.get('number')),
            complement: valuesHelper.get('complement'),
            district: valuesHelper.get('district'),
            city: valuesHelper.get('city'),
            uf: valuesHelper.get('uf'),
            country: Number(valuesHelper.get('country')),
            type: 1,
            address_type: 'representative',
          },
          person: {
            email: valuesHelper.get('email'),
            full_name: valuesHelper.get('full_name'),
            birth_date: valuesHelper.get('birth_date')
              ? valuesHelper.get('birth_date').split('/').reverse().join('-')
              : null,
            marital_status: valuesHelper.get('marital_status'),
            naturalness: valuesHelper.get('nationality'),
            naturalness_state: valuesHelper.get('naturalness'),
            naturalness_city: valuesHelper.get('naturalness_city'),

            occupation: valuesHelper.get('occupation'),

            cellphone: {
              type: 'phone',
              code: Number(valuesHelper.get('celphone_ddi')),
              number: Utils.onlyNumbers(valuesHelper.get('celphone_number')),
              branch: 0,
            },

            document: {
              type: 'CPF',
              number: Utils.onlyNumbers(valuesHelper.get('document')),
            },
            secondary_document: {
              number: valuesHelper.get('rg'),
              type: valuesHelper.get('document_type'),
              dispatching_agency: valuesHelper.get('issuing_agency'),
              uf: valuesHelper.get('issuing_uf'),
              expedition_date: valuesHelper.get('shipping_date')
                ? valuesHelper.get('shipping_date').split('/').reverse().join('-')
                : null,
            },
          },
        };

        const marital_status = valuesHelper.get('marital_status');

        if (marital_status === '2' || marital_status === '3') {
          payload['register']['person']['spouse'] = {
            name: valuesHelper.get('spouse_name'),
            document: Utils.onlyNumbers(valuesHelper.get('spouse_document')),
            marriage_bond: valuesHelper.get('spouse_statute'),
          };
        }
      }

      if (this.foundedRegister !== null) {
        payload['registered'] = this.foundedRegister.id;
      }

      // Pega o register_uuid da rota (obrigatório, sem fallback)
      const routeId = this.route.snapshot.paramMap.get('id');

      if (!routeId) {
        this.toast.show(
          'error',
          'Erro',
          'Register UUID não encontrado na rota'
        );
        this.sending = false;
        return;
      }

      const params = { register_uuid: routeId };

      let response: ApiResponse<RepresentativeResponse>;
      if (this.selectedRepresentative !== null) {
        if (isCompany) {
          // simplified payload for company update
          const simplifiedPayload = {
            representative: {
              min_term_validity: valuesHelper.get('term_validity')
                ? valuesHelper.get('term_validity').split('/').reverse().join('-')
                : null,
              max_term_validity: valuesHelper.get('indefinite_term')
                ? null
                : valuesHelper.get('max_term_validity')
                ? valuesHelper.get('max_term_validity').split('/').reverse().join('-')
                : null,
              can_sign: false,
            },
          };

          await this.api.patch<ApiResponse<RepresentativeResponse>>({
            route: `api/registration/representatives-data/${
              this.data[this.selectedRepresentative].id
            }/`,
            params: params,
            token: true,
            body: simplifiedPayload,
          });

          this.toast.show('info', 'Sucesso', 'Representante atualizado com sucesso');
          this.form.reset();
          this.addAnotherModal = false;
          this.foundedRegister = null;
          this.selectedRepresentative = null;
          this.zipcodeFetched = false;
          this.representativeFetched = false;
          this.getDataAndFillForm();
          return;
        }

        response = await this.api.put<ApiResponse<RepresentativeResponse>>({
          route: `api/registration/representatives-data/${
            this.data[this.selectedRepresentative].id
          }/`,
          params: params,
          token: true,
          body: payload,
        });
      } else {
        response = await this.api.post<ApiResponse<RepresentativeResponse>>({
          route: 'api/registration/representatives-data/',
          params: params,
          token: true,
          body: payload,
        });
      }

      this.toast.show('info', 'Sucesso', response.message);

      this.form.reset();

      this.addAnotherModal = false;
      this.foundedRegister = null;
      this.selectedRepresentative = null;

      this.getDataAndFillForm();
    } catch (error) {
      console.error(error);
      if (error.error?.message?.includes('username')) {
        this.toast.show('error', 'Erro', 'Esse usuário já está em uso.');
      } else {
        this.toast.show(
          'error',
          'Erro',
          error.error?.message || 'Ocorreu um erro ao salvar os dados'
        );
      }
    } finally {
      this.sending = false;
    }
  }

  formatCpf(document: string) {
    return this.maskPipe.transform(document, '000.000.000-00');
  }

  formatCpfCnpj(document: string | null | undefined): string {
    if (!document) {
      return '';
    }
    const digits = document.replace(/\D/g, '');
    if (digits.length === 14) {
      return this.maskPipe.transform(digits, '00.000.000/0000-00');
    }
    if (digits.length === 11) {
      return this.maskPipe.transform(digits, '000.000.000-00');
    }
    return document;
  }

  getRepresentativeType(row: RepresentativeResponse): string {
    // Verificar se há dados de empresa
    const companyData =
      row.info?.company ||
      row.info?.register?.company ||
      row.representative_register?.company;
    const hasCompanyData =
      companyData &&
      ((companyData.document?.number &&
        companyData.document.number.trim() !== '') ||
        (companyData.corporate_name &&
          companyData.corporate_name.trim() !== ''));
    return hasCompanyData ? 'Empresa' : 'Pessoa';
  }

  getRepresentativeName(row: RepresentativeResponse): string {
    // Verificar se há dados de empresa
    const companyData =
      row.info?.company ||
      row.info?.register?.company ||
      row.representative_register?.company;
    const hasCompanyData =
      companyData &&
      ((companyData.document?.number &&
        companyData.document.number.trim() !== '') ||
        (companyData.corporate_name &&
          companyData.corporate_name.trim() !== ''));

    if (hasCompanyData && companyData.corporate_name) {
      return companyData.corporate_name;
    }
    return row.full_name || '';
  }

  getRepresentativeDocument(row: RepresentativeResponse): string {
    // Verificar se há dados de empresa
    const companyData =
      row.info?.company ||
      row.info?.register?.company ||
      row.representative_register?.company;
    const hasCompanyData =
      companyData &&
      ((companyData.document?.number &&
        companyData.document.number.trim() !== '') ||
        (companyData.corporate_name &&
          companyData.corporate_name.trim() !== ''));

    if (hasCompanyData && companyData.document?.number) {
      return this.maskPipe.transform(
        companyData.document.number,
        '00.000.000/0000-00'
      );
    }
    return this.formatCpf(row.document_number);
  }

  canEditRepresentative = (row: RepresentativeResponse): boolean => {
    // Permitir editar todos os representantes (inclusive empresas)
    return true;
  };

  handleRepresentativeTypeChange(value: any, type: string) {
    const currentType = this.form.controls.representative_type.value;
    let newType: string;

    // Se o valor for null ou false (clicou novamente no mesmo radiobutton)
    if (value === null || value === false) {
      // Alterna para o outro tipo
      newType = currentType === 'person' ? 'company' : 'person';
    } else {
      // Se clicou no outro radiobutton, seta o tipo correspondente
      newType = type;
    }

    // Se o tipo realmente mudou, resetar todos os campos imediatamente
    if (currentType !== newType) {
      // Preservar apenas alguns valores padrão
      const preservedValues = {
        representative_type: newType,
        nationality: '23',
        celphone_ddi: '55',
      };

      // Resetar flags antes do reset
      this.representativeFetched = false;
      this.foundedRegister = null;
      this.zipcodeFetched = false;
      this.isForeign = false; // Sempre Brasil após reset
      this.resetCompanyLookupState();

      // Resetar o formulário
      this.form.reset();

      // Garantir que o campo document (CPF) seja limpo explicitamente
      this.form.controls.document.setValue(null, { emitEvent: false });

      // Restaurar valores preservados sem disparar eventos
      this.form.patchValue(preservedValues, { emitEvent: false });

      // Aplicar validações do novo tipo
      this.applyRepresentativeTypeValidations(newType);
    }

    // Atualizar o valor do tipo
    this.form.controls.representative_type.setValue(newType, {
      emitEvent: false,
    });
  }

  private resetCompanyLookupState() {
    this.companyLookupName = null;
    this.companyLookupId = null;
    this.companyRepresentativeRegisterUuid = null;
    this.companyLookupStatus = null;

    this.lastCompanyCnpjDigits = '';
    this.companyCnpjComplete = false;
    this.companyRepresentatives = [];
  }

  handleHaveAgent(haveAgent: boolean) {
    if (haveAgent) {
      if (this.data.length === 0) {
        this.signupService.setPersonFormStatus(
          'complementaryRepresentatives',
          false
        );
      } else {
        this.signupService.setPersonFormStatus(
          'complementaryRepresentatives',
          true
        );
      }
    } else {
      this.signupService.setPersonFormStatus(
        'complementaryRepresentatives',
        true
      );
    }

    this.signupService.setPersonFormData('haveAgent', haveAgent);
  }

  // Expandable company representatives methods
  toggleRowExpansion(index: number) {
    if (this.expandedRows.has(index)) {
      this.expandedRows.delete(index);
    } else {
      this.expandedRows.add(index);
      // Load company representatives if not already loaded
      if (!this.companyRepresentativesMap.has(index)) {
        this.loadCompanyRepresentatives(index);
      }
    }
  }

  isRowExpanded(index: number): boolean {
    return this.expandedRows.has(index);
  }

  async loadCompanyRepresentatives(index: number) {
    const representative = this.data[index];
    const companyUuid = this.getCompanyUuid(representative);

    if (!companyUuid) {
      console.error('No company UUID found for representative at index', index);
      return;
    }

    this.loadingCompanyRepsMap.set(index, true);

    try {
      const res = await this.api.get<{
        data: Array<{
          id: number;
          full_name: string;
          document_number: string;
          signs_registration_form: boolean;
          is_registration_form_mandatory: boolean;
          has_signed: boolean;
          representative_register_uuid: string;
        }>;
      }>({
        route: 'api/registration/registration-sign-status/',
        params: { register_uuid: companyUuid },
        token: true,
      });

      const representatives = (res?.data || []).map((item) => ({
        name: item.full_name,
        document: item.document_number,
        canSign: item.signs_registration_form,
        isMandatory: item.is_registration_form_mandatory,
      }));

      this.companyRepresentativesMap.set(index, representatives);
    } catch (error) {
      console.error('Error loading company representatives:', error);
      this.toast.show('error', 'Erro', 'Erro ao carregar representantes da empresa');
      this.companyRepresentativesMap.set(index, []);
    } finally {
      this.loadingCompanyRepsMap.set(index, false);
    }
  }

  isCompanyRepresentative(row: RepresentativeResponse): boolean {
    const companyData =
      row.info?.company ||
      row.info?.register?.company ||
      row.representative_register?.company;
    
    return !!(
      companyData &&
      ((companyData.document?.number && companyData.document.number.trim() !== '') ||
        (companyData.corporate_name && companyData.corporate_name.trim() !== ''))
    );
  }

  getCompanyUuid(row: RepresentativeResponse): string | null {
    // For company representatives, use the company's register_uuid from info.company
    return row.info?.company?.register_uuid || null;
  }

  getCompanyRepresentatives(index: number) {
    return this.companyRepresentativesMap.get(index) || [];
  }

  isLoadingCompanyReps(index: number): boolean {
    return this.loadingCompanyRepsMap.get(index) || false;
  }
}
